/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { I as InputMessage, d as defineCustomElement$1 } from './input-message.js';

const CalciteInputMessage = InputMessage;
const defineCustomElement = defineCustomElement$1;

export { CalciteInputMessage, defineCustomElement };

//# sourceMappingURL=calcite-input-message.js.map